import { getUnixTime, add, format } from 'date-fns'
import { debounce } from 'js/lib/general-utils'
import autosize from 'autosize'
import I18n from 'js/lib/i18n.js.erb'
;(function (window, $, userAgent, maxUploadSize) {
  $(document).ready(function () {
    var runScripts =
      $(document.body).hasClass('conversations-show') || $(document.body).hasClass('listings-conversations-show')

    if (runScripts) {
      var isMobile = /Mobi|Android/i.test(userAgent)
      var $root = $('.conversations--show')
      var $container = $root.find('.conversation-container')
      var $messageWindow = $container.find('.conversation-window')
      var $autoScrollIndicator = $container.find('.conversation-window--auto-scroll .indicator')
      var $messageForm = $container.find('.conversation-input form')
      var $messageInput = $messageForm.find('textarea[name="message"]')
      var $attachmentWindow = $messageForm.find('.attachments')
      var $attachmentErrorWindow = $attachmentWindow.find('.error-container')
      var $attachmentProgressContainer = $attachmentWindow.find('.progress-container')
      var $attachmentProgressBar = $attachmentProgressContainer.find('.progress-bar')
      var $attachmentLabel = $('.add_attachment')
      var $filesWindow = $attachmentWindow.find('.file-container')
      var yourSenderId = $messageForm.data('sender-id')
      var yourSenderName = $messageForm.data('sender-name')
      var pollUrl = $messageWindow.data('poll-url')
      var lastCreatedAt = $messageWindow.find('.message-wrapper:last').data('created-at')
      var $slider = $('.pswp')
      var $timeSent = $('.sent-at')

      //scroll to bottom on load
      $messageWindow.scrollTop($messageWindow.prop('scrollHeight'))

      // Add 1 second to createdSince to account for microsecond
      // in query when polling for new messages
      var createdSince = add(new Date(lastCreatedAt * 1000), { seconds: 1 })

      $timeSent.each(function (index, value) {
        var time = new Date(value.dataset.timesent)
        $(value).text(format(time, 'd/MM/yyyy h:mma'))
      })

      $messageWindow.on('click', 'a', function (e) {
        $.externalLinkWarning.try(this).done(function () {
          e.preventDefault()
        })
      })

      $messageWindow.on(
        'scroll',
        debounce(function () {
          var scrollTop = $(this).scrollTop()
          var clientHeight = $(this).prop('clientHeight')
          var scrollHeight = $(this).prop('scrollHeight')

          if (scrollTop + clientHeight < scrollHeight) {
            $autoScrollIndicator.stop(true, false).fadeIn(200)
          } else if ($autoScrollIndicator.is(':visible')) {
            $autoScrollIndicator.stop(true, false).fadeOut(200)
          }
        }, 300)
      )

      $autoScrollIndicator.on('click', function () {
        $messageWindow.stop(true, false).animate(
          {
            scrollTop: $messageWindow.prop('scrollHeight'),
          },
          200
        )
      })

      // Scroll to bottom on load on mobile
      if (isMobile) {
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual'

          $(window).one('unload', function () {
            history.scrollRestoration = 'auto'
          })
        }

        $container.imagesLoaded(function () {
          var position = $container.position()
          var height = $container.outerHeight()
          var windowHeight = $(window).height()

          $(window).scrollTop(position.top + height - windowHeight)
        })
      }

      // Show attachment window (hidden without JS)
      $attachmentWindow.show()

      // Handle file upload
      $attachmentLabel.on('change', '.file-input', function () {
        var $self = $(this)
        var url = $self.data('url')

        $self.simpleUpload(url, {
          beforeSend: function (_, settings) {
            settings.contentType = 'multipart/form-data'
          },
          start: function () {
            // Hide Attach File link
            $attachmentLabel.hide()
            // Reset progress bar
            $attachmentProgressBar.css('width', 0)
            $attachmentProgressContainer.show()
            // Clear errors
            $attachmentErrorWindow.empty()
          },
          progress: function (progress) {
            var progressPercent = Math.round(progress) + '%'

            $attachmentProgressBar.stop(true, false).animate({
              width: progressPercent,
            })
          },
          success: function (response) {
            var filename = response.data.attachment.filename
            var filesize = response.data.attachment.file_size
            var title = filename + ' (' + $.humanFileSize(filesize) + ')'
            var image

            // Preload image
            if (response.data.attachment.file_type === 'image') {
              image = new Image()
              image.src = response.data.attachment.file_url
            }

            // Add attachment icon
            $filesWindow.append(
              $('<div >', {
                class: 'file',
                text: title,
                title: title,
              })
                .append(
                  $('<i >', {
                    class: 'delete-file fa fa-remove',
                  })
                )
                .data({
                  attachmentId: response.data.attachment.id,
                  attachmentUid: response.data.attachment.uid,
                  attachmentFileSize: response.data.attachment.file_size,
                })
            )

            // Replace the file input (buggy if we don't)
            $self.replaceWith($self.clone())
            // Hide progress bar and show Attach File link
            $attachmentProgressContainer.hide()
            $attachmentLabel.show()
            updateTotalAttachmentProgress()
            updateSubmitState()
          },
          error: function (error) {
            var response = error.xhr.responseJSON

            $.each(response.data.full_errors, function (_, message) {
              $attachmentErrorWindow.append(
                $('<span >', {
                  class: 'error',
                  text: message,
                })
              )
            })

            $attachmentProgressContainer.hide()
            $attachmentLabel.show()
            updateSubmitState()
          },
        })
      })

      // Handle deleting files
      $filesWindow.on('click', '.delete-file', function () {
        var $self = $(this)
        var url = $('.add_attachment').find('.file-input').data('url')
        var attachmentUid = $(this).parent().data('attachment-uid')

        $.ajax({
          url: url,
          type: 'DELETE',
          data: {
            attachment: {
              uid: attachmentUid,
            },
          },
          dataType: 'json',
          success: function () {
            $self.parent().remove()
            updateTotalAttachmentProgress()
            updateSubmitState()
          },
        })
      })

      // Only enable Send button when the message is not blank
      $messageInput.on('change keyup', debounce(updateSubmitState, 100)).trigger('change')

      // Autosize the message textarea on first focus
      // if we autosize on load it makes it too big
      $messageInput.one('focus', function () {
        autosize($messageInput)
      })

      // Handle message creation when the form is submitted
      $messageForm.on('submit', function (e) {
        var attachmentIds = $filesWindow
          .find('> .file')
          .map(function () {
            return $(this).data('attachment-id')
          })
          .get()

        $.ajax({
          url: $messageForm.prop('action'),
          type: 'POST',
          data: {
            message: $messageInput.val(),
            attachment_ids: attachmentIds,
          },
          dataType: 'json',
          success: function (response) {
            $filesWindow.find('> .file').remove()
            updateTotalAttachmentProgress()
            $messageWindow.append(createMessage(response.data.message, yourSenderName, true))
            $messageInput.val('').trigger('change')
            $messageWindow.animate(
              {
                scrollTop: $messageWindow.prop('scrollHeight'),
              },
              200
            )
          },
        })

        e.preventDefault()
      })

      // Image slider
      $messageWindow.on('click', '.attachment--image img', function () {
        var gallery
        var sliderImages = []
        var images = []

        $messageWindow.find('.message-wrapper').each(function () {
          images = $(this).find('.attachment--image img').get().concat(images)
        })

        for (var index in images) {
          var $image = $(images[index])

          sliderImages.push({
            src: $image.prop('src'),
            w: $image.data('width'),
            h: $image.data('height'),
            $el: $image,
          })
        }

        // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
        gallery = new PhotoSwipe($slider.get(0), PhotoSwipeUI_Default, sliderImages, {
          index: images.indexOf(this),
          bgOpacity: 0.8,
          pinchToClose: false,
          closeOnScroll: false,
          history: false,
          shareEl: false,
          getThumbBoundsFn: function (index) {
            var $thumbnail = sliderImages[index].$el

            return {
              x: $thumbnail.offset().left,
              y: $thumbnail.offset().top,
              w: $thumbnail.width(),
            }
          },
        })
        // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

        $('html, body').css('overflow', 'hidden')

        gallery.init()

        gallery.listen('close', function () {
          $('html, body').css('overflow', 'auto')
        })
      })

      // Poll for new messages
      ;(function pollForMessages() {
        setTimeout(function () {
          $.ajax({
            url: pollUrl,
            type: 'GET',
            data: {
              created_since: createdSince.toISOString(),
            },
            dataType: 'json',
            success: function (response) {
              var scrollTop = $messageWindow.scrollTop()
              var clientHeight = $messageWindow.prop('clientHeight')
              var scrollHeight = $messageWindow.prop('scrollHeight')
              var autoScrollEnabled = scrollTop + clientHeight === scrollHeight
              var $newMessages = $(response.data.messages)

              if (response.data.messages.length === 0) {
                return
              }

              $newMessages.each(function (_, message) {
                var $messages = $messageWindow.find('.message-wrapper')
                var $newMessage, $matched
                var $existingMessage = $messages.filter(function () {
                  return $(this).data('id') === message.id
                })

                if ($existingMessage.length > 0) {
                  return true
                }

                // Create message based on sender
                // current user displays on the left
                // other users on the right
                if (message.participant_id === yourSenderId) {
                  $newMessage = createMessage(message, yourSenderName, true)
                } else {
                  $newMessage = createMessage(message, message.participant_name, false)
                }

                // Find the first message where the sent-at date is less than
                // the new message sent-at date
                $messages.reverse().each(function () {
                  var $message = $(this)
                  if ($message.data('sent-at') < $newMessage.data('sent-at')) {
                    $matched = $message
                    return false
                  }
                })

                // Add the new message below that message
                $newMessage.insertAfter($matched)

                if (autoScrollEnabled) {
                  $messageWindow.animate(
                    {
                      scrollTop: $messageWindow.prop('scrollHeight'),
                    },
                    200
                  )
                }
              })

              // Update createdSince to the last new message createdAt date
              // +1 second to account for microsecond when querying for
              // later messages
              createdSince = add(new Date($newMessages.get(-1).created_at), { seconds: 1 })
            },
            complete: pollForMessages,
          })
        }, 30000)
      })()
    }
  })

  function createMessage(message, senderName, isCurrentUser) {
    var sentAt = new Date(message.sent_at)
    var createdAt = new Date(message.created_at)
    var wrapperClass, $wrapper, $message

    if (isCurrentUser) {
      wrapperClass = 'right'
    } else {
      wrapperClass = 'left'
    }

    // Create wrapper
    $wrapper = $('<div >', {
      class: 'message-wrapper ' + wrapperClass,
    }).data({
      id: message.id,
      senderName: senderName,
      sentAt: getUnixTime(sentAt),
      createdAt: getUnixTime(createdAt),
    })

    // Add sender name
    $wrapper.append(
      $('<span >', {
        class: 'sender-name',
        text: senderName,
      })
    )

    if (message.body.length > 0) {
      // Add message and notices
      $message = $('<div >', {
        class: 'message',
        html: message.body_html,
      })

      // NOTE: The UI is not designed handle multiple notices, but we only have 1
      //       at the moment
      if (!$.isEmptyObject(message.data.notices)) {
        $.each(message.data.notices, function (attribute, notices) {
          $.each(notices, function (_, notice) {
            var key = ['chat.messages.notices', attribute, notice.code].join('.')

            $message.append(
              $('<i >', {
                class: 'fa fa-info-circle tooltip',
                title: I18n.t(key, { value: notice.value }),
              })
            )
          })
        })
      }

      $wrapper.append($message)
    }

    // Add attachments if present
    if (message.attachments.length > 0) {
      $.each(message.attachments, function (_, attachment) {
        if (attachment.file_type === 'image') {
          var orientation = attachment.data.orientation
          var width = attachment.data.width
          var height = attachment.data.height
          var heightPercent = (height / width) * 100

          $wrapper.append(
            $('<div >', {
              class: 'attachment attachment--image ' + orientation,
            }).append(
              $('<div >', {
                class: 'image-container',
                style: 'max-width: ' + width + 'px;',
              }).append(
                $('<div >', {
                  class: 'image-placeholder',
                  style: 'padding-top: ' + heightPercent.toFixed(2) + '%;',
                }).append(
                  $('<img >', {
                    src: attachment.file_url,
                    alt: attachment.filename,
                  }).data({
                    width: attachment.data.width,
                    height: attachment.data.height,
                  })
                )
              )
            )
          )
        } else {
          $wrapper.append(
            $('<a >', {
              class: 'attachment attachment--file',
              href: attachment.file_url,
              text: attachment.filename,
              target: '_blank',
            })
          )
        }
      })
    }

    // Add timestamp
    $wrapper.append(
      $('<span >', {
        class: 'sent-at',
        text: formatDate(sentAt),
      })
    )

    return $wrapper
  }

  function updateTotalAttachmentProgress() {
    var $root = $('.conversations--show')
    var $attachmentWindow = $root.find('.attachments')
    var $totalProgressContainer = $attachmentWindow.find('.total-progress-container')
    var $totalProgressBar = $totalProgressContainer.find('.progress-bar')
    var $totalProgressLabel = $attachmentWindow.find('.total-progress-label')
    var totalAttachmentSize = getTotalAttachmentSize()
    var totalAttachmentSizeMb = totalAttachmentSize / 1048576
    var maxUploadSizeMb = maxUploadSize / 1048576
    var totalProgressPercent = Math.min.apply(null, [100, parseInt((totalAttachmentSizeMb / maxUploadSizeMb) * 100)])

    if (totalAttachmentSize > 0) {
      $totalProgressContainer.show()
      $totalProgressLabel.show()
    }

    $totalProgressBar.animate(
      {
        width: totalProgressPercent + '%',
      },
      function () {
        if (totalProgressPercent >= 100) {
          $totalProgressContainer.removeClass('warn').addClass('error')
          $totalProgressLabel.removeClass('warn').addClass('error')
        } else if (totalProgressPercent >= 65) {
          $totalProgressContainer.removeClass('error').addClass('warn')
          $totalProgressLabel.removeClass('error').addClass('warn')
        } else {
          $totalProgressContainer.removeClass('warn error')
          $totalProgressLabel.removeClass('warn error')

          if (totalAttachmentSize === 0) {
            $totalProgressContainer.hide()
            $totalProgressLabel.hide()
          }
        }
      }
    )
    $totalProgressLabel.text(
      I18n.t('conversations.show.total_attachment_progress', { size: $.humanFileSize(totalAttachmentSize) })
    )
  }

  function getTotalAttachmentSize() {
    var $root = $('.conversations--show')
    var $filesWindow = $root.find('.file-container')
    var $attachments = $filesWindow.find('> .file')
    var total = 0

    $attachments.each(function (_, attachment) {
      total += $(attachment).data('attachment-file-size')
    })

    return total
  }

  function updateSubmitState() {
    var $root = $('.conversations--show')
    var $messageInput = $root.find('textarea[name="message"]')
    var $filesWindow = $root.find('.file-container')
    var $submitButton = $root.find('.submit')
    var messageText = $.trim($messageInput.val())
    var $attachments = $filesWindow.find('> .file')
    var totalAttachmentSize = getTotalAttachmentSize()

    if ((messageText.length === 0 && $attachments.length === 0) || totalAttachmentSize > maxUploadSize) {
      $submitButton.addClass('disabled').prop('disabled', true)
    } else {
      $submitButton.removeClass('disabled').prop('disabled', false)
    }
  }

  function formatDate(date) {
    return format(date, 'd/MM/yyyy h:mma')
  }
})(window, jQuery, navigator.userAgent, 15728640)
